import ScrollableTableWrapper from 'components/table/components/ScrollableTableWrapper';
import TableSkeleton from 'components/table/components/TableSkeleton';
import Thead from 'components/table/components/thead';
import useText from 'hooks/useText';
import ReviewTableRow from './ReviewTableRow';

/**
 * The reviews the companies left their temp workers, in the table of the
 * tasks and the companies. `reviews` is null while they are read.
 */
const ReviewTable = ({
  reviews,
  untreated,
  busy,
  selectedId,
  isLeaving,
  onLeaveEnd,
  onOpen,
  onOpenWorker,
  onOpenCompany,
}) => {
  const { text } = useText('reviews');
  // Who left the review is an avatar: no title over it.
  const header = [
    text('columnWorker'),
    text('columnMission'),
    text('columnReview'),
    '',
  ];
  return (
    <ScrollableTableWrapper>
      <table
        className={`w-full table-auto text-gray-500 ft-sm transition-opacity ${busy ? 'opacity-60' : ''}`}
      >
        <thead className="sticky top-0 z-10">
          <Thead champsHeader={header} pathname="/reviews" />
        </thead>
        {reviews ? (
          <tbody>
            {reviews.map((review, index) => (
              <ReviewTableRow
                key={review._id}
                review={review}
                index={index}
                untreated={untreated}
                selectedId={selectedId}
                leaving={isLeaving(review._id)}
                onLeaveEnd={onLeaveEnd(review._id)}
                onOpen={onOpen}
                onOpenWorker={onOpenWorker}
                onOpenCompany={onOpenCompany}
              />
            ))}
          </tbody>
        ) : (
          // Thead adds an empty column for the actions.
          <TableSkeleton columns={header.length + 1} label={text('loading')} />
        )}
      </table>
    </ScrollableTableWrapper>
  );
};

export default ReviewTable;
